/**
 * The Statsig gate for onboarding v3 (`docs/prds/onboarding.md`): no setup
 * thread, and personalized suggestions on the new chat screen.
 *
 * Lives here because all three packages read it: the server decides the flow
 * and serves the suggestions, web asks for suggestions under it, and native
 * lands its users on the new chat screen under it.
 *
 * Read at sign-up, before a phone number is verified, so a rule targeting by
 * phone number would not reach sign-ups.
 */
export const ONBOARDING_V3_GATE = "onboarding-v3";
